(function ($) {
  $(document).ready(function () {
    $(".nav-opener").click(function () {
      $("body").toggleClass("nav-active");
      return false;
    });

    $(".btn-popup").click(function () {
      $("body").addClass("popup-active");
      return false;
    });

    $(".popup-close").click(function () {
      $("body").removeClass("popup-active");
      return false;
    });

    $(".product-specs .title").click(function () {
      $(this)
        .next(".slide")
        .slideToggle("slow")
        .siblings(".slide:visible")
        .slideUp("slow");
      $(this).parent().toggleClass("active");
    });

    $(".home-news-gallery").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
    });

    $(".product-details-gallery").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
    });

    $(".productdetails-steps-gallery").slick({
      arrows: false,
      dots: true,
      fade: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    });

    $(".home-benefits-gallery").slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
          },
        },
      ],
    });

    $(".reviews-news-gallery").slick({
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    });

    $(".video-gallery").slick({
      arrows: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      loop: false,
      infinite: false,
      responsive: [
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });

    $(".reviews-gallery__slide--block").slick({
      fade: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            dots: true,
            arrows: false,
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            dots: true,
            arrows: false,
            slidesToShow: 1,
          },
        },
      ],
    });

    $(".product-slider").slick({
      slidesToScroll: 1,
      rows: 0,
      slidesToShow: 1,
      infinite: false,
      dots: true,
      asNavFor: ".product-nav",
      responsive: [
        {
          breakpoint: 768,
          settings: {
            dots: true,
            vertical: false,
            slidesToShow: 1,
          },
        },
      ],
    });

    $(".product-nav").slick({
      slidesToScroll: 1,
      rows: 0,
      slidesToShow: 6,
      infinite: false,
      arrows: false,
      asNavFor: ".product-slider",
      focusOnSelect: true,
      variableWidth: true,
      vertical: true,
    });

    //   $('.home-reviews-gallery').slick({
    //     slidesToShow: 2,
    //     slidesToScroll: 1,
    //     responsive: [
    //       {
    //         breakpoint: 1023,
    //         settings: {
    //             slidesToShow: 2
    //         }
    //       },
    //       {
    //         breakpoint: 767,
    //         settings: {
    //             slidesToShow: 1
    //         }
    //       }
    //     ]
    // });

    // $(".product-reviews-gallery").slick({
    //   slidesToShow: 2,
    //   slidesToScroll: 1,
    //   arrows: false,
    //   responsive: [
    //     {
    //       breakpoint: 1023,
    //       settings: {
    //         slidesToShow: 2,
    //       },
    //     },
    //     {
    //       breakpoint: 767,
    //       settings: {
    //         slidesToShow: 1,
    //       },
    //     },
    //   ],
    // });

    $(".collection-gallery").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  });
})(jQuery);
